import React from 'react';
import styles from './FormField.module.scss';

interface PortalSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  hasError?: boolean;
  children: React.ReactNode;
}

export function PortalSelect({ hasError, className, children, ...props }: PortalSelectProps) {
  const classes = [styles.portalSelect, hasError ? styles.inputError : '', className].filter(Boolean).join(' ');
  return (
    <select className={classes} {...props}>
      {children}
    </select>
  );
}
